// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"0680fb27","403":"31e65e31","453":"eb570f4f","557":"96087b2b","599":"6e10258c","685":"96afccf8","880":"b622b52d"}[chunkId] + ".chunk.js";
};